// AUTO-GENERATED by tools/measure-ink-offsets.mjs — DO NOT hand-edit.
// Run `npm run fonts:ink` to regenerate (do this whenever fonts are added/changed).
//
// Per-font advance-width ratios [DIGIT, UPPERCASE, lowercase] as a fraction of EM (canvas
// measureText). render-engine.js sizes the weight lockup's unit line off the ACTUAL glyph
// widths so its width matches the number exactly — digits run narrower than letters, so a
// single average width ratio left long marks (POUNDS) wider than the number.
export default {
  "abril": [0.569, 0.672, 0.533],
  "alfaslab": [0.661, 0.783, 0.608],
  "annie": [0.421, 0.461, 0.362],
  "anton": [0.478, 0.474, 0.455],
  "archivo": [0.596, 0.706, 0.54],
  "archivoblack": [0.667, 0.769, 0.615],
  "archivonarrow": [0.456, 0.564, 0.442],
  "baloo": [0.527, 0.603, 0.517],
  "bangers": [0.447, 0.419, 0.42],
  "barlow": [0.517, 0.607, 0.498],
  "barlowcond": [0.426, 0.467, 0.411],
  "bbhbartle": [1.283, 1.317, 1.317],
  "bebas": [0.4, 0.389, 0.389],
  "bigshoulders": [0.414, 0.414, 0.387],
  "blackops": [0.686, 0.707, 0.616],
  "bodoni": [0.585, 0.733, 0.561],
  "bowlby": [0.717, 0.758, 0.677],
  "bowlbyone": [0.717, 0.758, 0.704],
  "bungee": [0.665, 0.711, 0.711],
  "bungeeshade": [0.765, 0.811, 0.811],
  "cardo": [0.512, 0.721, 0.482],
  "castorotitling": [0.54, 0.7, 0.7],
  "caveat": [0.449, 0.506, 0.364],
  "chakra": [0.573, 0.638, 0.526],
  "changaone": [0.6, 0.58, 0.528],
  "chango": [0.81, 0.934, 0.766],
  "chivo": [0.615, 0.665, 0.551],
  "cinzel": [0.555, 0.708, 0.643],
  "cinzeldeco": [0.575, 0.738, 0.725],
  "college": [0.488, 0.559, 0.511],
  "collegebold": [0.508, 0.598, 0.539],
  "collegecond": [0.391, 0.465, 0.415],
  "collegesemi": [0.439, 0.512, 0.463],
  "courgette": [0.527, 0.59, 0.493],
  "courierprime": [0.6, 0.6, 0.6],
  "dancing": [0.539, 0.635, 0.4],
  "danfo": [0.597, 0.64, 0.64],
  "dmsans": [0.586, 0.657, 0.548],
  "dmserif": [0.504, 0.608, 0.513],
  "dosis": [0.502, 0.562, 0.462],
  "ebgaramond": [0.513, 0.676, 0.465],
  "epilogue": [0.58, 0.636, 0.569],
  "figtree": [0.57, 0.664, 0.52],
  "firacond": [0.483, 0.538, 0.471],
  "fjallaone": [0.48, 0.482, 0.434],
  "fraunces": [0.591, 0.724, 0.556],
  "fugaz": [0.617, 0.659, 0.565],
  "germania": [0.468, 0.498, 0.437],
  "girlnextdoor": [0.354, 0.544, 0.483],
  "gloria": [0.521, 0.661, 0.524],
  "goldman": [0.713, 0.803, 0.633],
  "graduate": [0.65, 0.665, 0.665],
  "greatvibes": [0.382, 0.97, 0.317],
  "hanken": [0.56, 0.647, 0.51],
  "inter": [0.61, 0.694, 0.553],
  "jakarta": [0.597, 0.677, 0.554],
  "josefin": [0.522, 0.698, 0.511],
  "josefinslab": [0.492, 0.671, 0.483],
  "jost": [0.61, 0.663, 0.509],
  "kanit": [0.539, 0.624, 0.529],
  "kaushan": [0.556, 0.654, 0.44],
  "khand": [0.421, 0.447, 0.409],
  "labelle": [0.504, 0.641, 0.428],
  "leaguegothic": [0.333, 0.353, 0.293],
  "lexend": [0.581, 0.714, 0.571],
  "librebaskerville": [0.594, 0.793, 0.587],
  "lilita": [0.543, 0.61, 0.49],
  "lobster": [0.486, 0.591, 0.442],
  "lora": [0.538, 0.685, 0.537],
  "luckiestguy": [0.531, 0.588, 0.594],
  "lugrasimo": [0.579, 0.818, 0.609],
  "manrope": [0.586, 0.66, 0.551],
  "marcellus": [0.528, 0.636, 0.502],
  "michroma": [0.96, 1.013, 0.719],
  "moderustic": [0.6, 0.658, 0.538],
  "monoton": [0.678, 0.81, 0.757],
  "montserrat2": [0.607, 0.732, 0.601],
  "mulish": [0.6, 0.681, 0.54],
  "newamsterdam": [0.379, 0.393, 0.392],
  "newrocker": [0.517, 0.679, 0.48],
  "nixie": [0.565, 0.69, 0.563],
  "nunito": [0.6, 0.676, 0.526],
  "ooohbaby": [0.561, 0.695, 0.395],
  "orbitron": [0.758, 0.816, 0.635],
  "oswald": [0.502, 0.532, 0.453],
  "outfit": [0.545, 0.666, 0.51],
  "overpass": [0.583, 0.651, 0.522],
  "pacifico": [0.519, 0.81, 0.456],
  "passionone": [0.483, 0.542, 0.477],
  "pathwaygothic": [0.377, 0.386, 0.351],
  "paytone": [0.56, 0.658, 0.592],
  "permanentmarker": [0.553, 0.672, 0.551],
  "playfair": [0.516, 0.679, 0.526],
  "playwriteau": [0.736, 0.844, 0.565],
  "pompiere": [0.431, 0.454, 0.33],
  "poppins": [0.594, 0.667, 0.582],
  "prata": [0.591, 0.745, 0.547],
  "ptsansnarrow": [0.478, 0.484, 0.401],
  "questrial": [0.55, 0.65, 0.502],
  "quicksand": [0.549, 0.655, 0.546],
  "racingsans": [0.582, 0.613, 0.53],
  "rajdhani": [0.494, 0.539, 0.468],
  "redhat": [0.581, 0.689, 0.528],
  "reenie": [0.364, 0.44, 0.338],
  "righteous": [0.567, 0.632, 0.522],
  "roboto": [0.574, 0.641, 0.507],
  "robotocond": [0.505, 0.56, 0.449],
  "rowdies": [0.671, 0.756, 0.574],
  "rozha": [0.515, 0.603, 0.546],
  "rubik": [0.618, 0.671, 0.563],
  "rubikmono": [0.85, 0.85, 0.85],
  "rye": [0.646, 0.729, 0.602],
  "sairacond": [0.445, 0.474, 0.407],
  "sciencegothic": [0.815, 0.875, 0.676],
  "shrikhand": [0.689, 0.744, 0.618],
  "sigmar": [0.659, 0.814, 0.713],
  "silkscreen": [0.863, 0.865, 0.865],
  "sora": [0.634, 0.725, 0.591],
  "spacegrotesk": [0.59, 0.629, 0.554],
  "specialelite": [0.579, 0.601, 0.577],
  "spectral": [0.536, 0.722, 0.515],
  "squadaone": [0.437, 0.456, 0.419],
  "staatliches": [0.422, 0.441, 0.442],
  "teko": [0.468, 0.51, 0.443],
  "tektur": [0.616, 0.636, 0.565],
  "titanone": [0.615, 0.685, 0.631],
  "tuffy": [0.575, 0.635, 0.498],
  "ultra": [0.699, 0.834, 0.726],
  "urbanist": [0.528, 0.636, 0.515],
  "worksans": [0.585, 0.676, 0.557],
  "yanone": [0.4, 0.377, 0.335],
  "yellowtail": [0.382, 0.66, 0.37],
  "yeseva": [0.573, 0.683, 0.572],
  "ysabeausc": [0.491, 0.655, 0.525],
  "zendots": [0.873, 0.909, 0.678],
  "zillaslab": [0.525, 0.658, 0.511],
};
